import React from "react";

export default function AddressSkeleton() {
  return (
    <div className="space-y-4 px-4 py-6">
      {[1, 2].map((_, idx) => (
        <div
          key={idx}
          className="bg-white p-4 rounded-md shadow animate-pulse space-y-3"
        >
          {/* Header with name and badge */}
          <div className="flex justify-between items-start">
            <div className="h-4 w-40 bg-gray-300 rounded"></div>
            <div className="h-6 w-12 bg-red-300 rounded-full"></div>
          </div>

          {/* Address lines */}
          <div className="space-y-2">
            <div className="h-4 w-28 bg-gray-200 rounded"></div>
            <div className="h-4 w-24 bg-gray-200 rounded"></div>
            <div className="h-4 w-36 bg-gray-200 rounded"></div>
            <div className="h-4 w-32 bg-gray-200 rounded"></div>
          </div>

          {/* Mobile */}
          <div className="h-4 w-44 bg-gray-300 rounded"></div>

          {/* Divider */}
          <div className="border-t my-2"></div>

          {/* Buttons */}
          <div className="flex justify-between">
            <div className="h-4 w-16 bg-gray-300 rounded"></div>
            <div className="h-4 w-12 bg-gray-300 rounded"></div>
          </div>
        </div>
      ))}
    </div>
  );
}
